'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var name = 'Redirect';

exports.default = { name: name, render: render };


function render() {
  throw new Error('<Redirect /> should not be rendered');
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9yZWRpcmVjdC5qcyJdLCJuYW1lcyI6WyJuYW1lIiwicmVuZGVyIiwiRXJyb3IiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUNBLElBQU1BLE9BQU8sVUFBYjs7a0JBRWUsRUFBRUEsVUFBRixFQUFRQyxjQUFSLEU7OztBQUVmLFNBQVNBLE1BQVQsR0FBa0I7QUFDaEIsUUFBTSxJQUFJQyxLQUFKLENBQVUscUNBQVYsQ0FBTjtBQUNEIiwiZmlsZSI6InJlZGlyZWN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiXG5jb25zdCBuYW1lID0gJ1JlZGlyZWN0J1xuXG5leHBvcnQgZGVmYXVsdCB7IG5hbWUsIHJlbmRlciB9XG5cbmZ1bmN0aW9uIHJlbmRlcigpIHtcbiAgdGhyb3cgbmV3IEVycm9yKCc8UmVkaXJlY3QgLz4gc2hvdWxkIG5vdCBiZSByZW5kZXJlZCcpXG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../~/@segment/deku-enroute/lib/redirect.js
// module id = 1040
// module chunks = 0